import ProdutoDescricaoModel from "./ProdutoDescricaoModel";
import AppState from "./AppState";
import LojaModel from "./LojaModel";
import C5ProdutoDAO from "../dataAccess/C5/C5ProdutoDAO";
import ObaPromocaoModel from "./ObaPromocaoModel";

export default class ProdutoModel {
  public produtoId: string = "";
  public nome: string = "";
  public nomeUnidade: string = "";
  public imagem: string = "";
  public marca: string = "";
  public categoria: string = "";
  public subcategoria: string = "";
  public subsubcategoria: string = "";
  public precoOriginal: number = 0;
  public precoDesconto: number = 0;
  public unidade: string = "";
  public descricoes: ProdutoDescricaoModel[] = [];
  public sku: string = "";
  public tipoPromocao: string = "";
  public fatorMultiplicacao: number = 0;
  public categoriaId: number = 0;
  public subcategoriaId: number = 0;
  public subsubcategoriaId: number = 0;
  public bemQuerer: boolean = false;
  public ff: boolean = false;
  public promo: ObaPromocaoModel = new ObaPromocaoModel();
  public quantidade: number = 1;
  public estoque: number = 0;
  public static CATEGORIA_ADEGA = 61;

  public static async requerMaioridade(item: ProdutoModel): Promise<boolean> {
    const loja: LojaModel | null = AppState.getLojaSelecionada();
    const produto: ProdutoModel | null = await C5ProdutoDAO.getInstance().getById(item.produtoId, loja ? loja.lojaId : null);
    
    if (loja && produto) {
      return +produto.categoriaId === this.CATEGORIA_ADEGA;
    } else {
      return false;
    }

  }

  public static getNome(item: ProdutoModel): string {
    let nome: string = item.nome;

    if (item.unidade === "GR") {
      let fatorTexto: string;
      if (item.fatorMultiplicacao < 1000) {
        fatorTexto = `${item.fatorMultiplicacao}g`;
      } else {
        fatorTexto = `${(item.fatorMultiplicacao / 1000)
          .toFixed(2)
          .replace(".", ",")
          .replace(",00", "")}Kg`;
      }

      nome = `${item.nome} (${fatorTexto})`;
    }
    return nome;
  }

  public static getNomeExtra(item: ProdutoModel, nomeExtra: string): string {
    const produto = JSON.parse(JSON.stringify(item));
    produto.nome += nomeExtra;
    return this.getNome(produto);
  }

  public static getGR(item: ProdutoModel, qtd: number = 1): string {
    if (item.unidade === "GR") {
      let fatorTexto: string;
      if ((item.fatorMultiplicacao * qtd) < 1000) {
        fatorTexto = `${item.fatorMultiplicacao * qtd}g`;
      } else {
        fatorTexto = `${(item.fatorMultiplicacao * qtd / 1000)
          .toFixed(2)
          .replace(".", ",")
          .replace(",00", "")}Kg`;
      }

      return fatorTexto;
    } else {
      return item.unidade;
    }
  }

  public static temEstoque(item: any): boolean {
    return true;
  }

  public static getDescricaoField(
    item: any,
    key: any
  ): ProdutoDescricaoModel | null {
    if (item && item[key] && item[key].length > 0) {
      let retText: string = "",
        descId: string = "";
      switch (key) {
        case "HTMLShorDescription":
          retText = "Descrição curta do produto";
          descId = "1";
          break;
        case "HTMLDescription":
          retText = "Descrição completa do produto";
          descId = "2";
          break;
        case "HTMLSpecifications":
          retText = "Mais dados do produto";
          descId = "3";
          break;
        case "HTMLTechnicalData":
          retText = "Descrição técnicos do produto";
          descId = "4";
          break;
        case "HTMLDeliveryTime":
          retText = "Detalhes de entrega";
          descId = "5";
          break;
        case "HTMLConnections":
          retText = "Conectividade do produto";
          descId = "6";
          break;
        case "HTMLAssurance":
          retText = "Segurança";
          descId = "7";
          break;
        default:
          break;
      }
      return {
        descricaoId: descId,
        titulo: retText,
        descricao: item[key]
      };
    }
    return null;
  }

  public static toModel(item: any): ProdutoModel | null {
    if (!item) {
      return null;
    }

    const descricoes: ProdutoDescricaoModel[] = [];

    let obj: ProdutoDescricaoModel | null = this.getDescricaoField(
      item,
      "HTMLShorDescription"
    );
    if (obj) {
      descricoes.push(obj);
    }

    obj = this.getDescricaoField(item, "HTMLDescription");
    if (obj) {
      descricoes.push(obj);
    }

    obj = this.getDescricaoField(item, "HTMLItemsIncluded");
    if (obj) {
      descricoes.push(obj);
    }

    obj = this.getDescricaoField(item, "HTMLRequirements");
    if (obj) {
      descricoes.push(obj);
    }

    obj = this.getDescricaoField(item, "HTMLSpecifications");
    if (obj) {
      descricoes.push(obj);
    }

    obj = this.getDescricaoField(item, "HTMLTechnicalData");
    if (obj) {
      descricoes.push(obj);
    }

    obj = this.getDescricaoField(item, "HTMLDeliveryTime");
    if (obj) {
      descricoes.push(obj);
    }

    const produtoModel = {
      produtoId: item.ID,
      nome: item.Name,
      imagem: item.ProductImageCDN,
      sku: item.Sku,
      unidade: item.MetricUnity,
      precoOriginal: item.OldPrice,
      precoDesconto: item.SalePrice,
      categoria: item.CategoryName,
      subcategoria: item.SubCategoryName,
      subsubcategoria: item.ThirdCategoryName,
      categoriaId: item.CategoryID,
      subcategoriaId: item.SubCategoryID,
      subsubcategoriaId: item.ThirdCategoryID,
      descricoes
    } as ProdutoModel;

    if (item.hasOwnProperty('ProductID')) {
      produtoModel.produtoId = item.ProductID;
    }

    return produtoModel;
  }

  public static toModelList(item: any): ProdutoModel {
    const descricoes: ProdutoDescricaoModel[] = [];
    return {
      produtoId: item.ProductID,
      nome: item.ProductName,
      imagem: item.ProductImageCDN,
      sku: item.Sku,
      unidade: item.SaleUnit,
      precoOriginal: item.ProductOldPrice,
      precoDesconto: item.ProductSalePrice,
      fatorMultiplicacao: item.WeightMultiplierFactor,
      descricoes
    } as ProdutoModel;
  }

  public static toModelByCategoriaProduto(
    item: any,
    tipo: string
  ): ProdutoModel | null {
    if (item.ShowSeal1) {
      AppState.setSelo(item.ProductID, 1, item.Seal1URL);
    }

    if (item.ShowSeal2) {
      AppState.setSelo(item.ProductID, 2, item.Seal2URL);
    }

    if (item.ShowSeal3) {
      AppState.setSelo(item.ProductID, 3, item.Seal3URL);
    }

    if (item.ShowSeal4) {
      AppState.setSelo(item.ProductID, 4, item.Seal4URL);
    }

    if (item.ShowSeal5) {
      AppState.setSelo(item.ProductID, 5, item.Seal5URL);
    }

    return {
      produtoId: item.ProductID,
      nome: item.ProductName,
      imagem: item.ProductImageCDN,
      sku: item.Sku,
      unidade: item.SaleUnit,
      fatorMultiplicacao: item.WeightMultiplierFactor,
      precoOriginal: item.ProductOldPrice,
      precoDesconto: item.ProductSalePrice,
      marca: item.Brand,
      categoria: "",
      categoriaId: 0,
      subcategoria: "",
      subcategoriaId: 0,
      subsubcategoria: "",
      subsubcategoriaId: 0,
      tipoPromocao: tipo,
      estoque: item.StockLength
    } as ProdutoModel;
  }
}
